<script>
  import { appState, queryState } from "../../../stores";

  // Constant
  const options = [
    { value: "", label: "Relevance" },
    { value: "date", label: "Date" },
    { value: "title", label: "Title" },
  ];

  // State
  $: sortValue = $queryState.sort ?? "";
  $: disabled = $appState.loading;

  // Handler
  const handleChange = (e) => {
    queryState.update((queryState) => ({
      ...queryState,
      sort: e.target.value,
      pg: null,
    }));

    if (window.matchMedia("(max-width: 980px)").matches) {
      requestAnimationFrame(() =>
        document
          .getElementById("mobile-results-and-filter")
          .scrollIntoView(true)
      );
    }
  };
</script>

<div class="wrapper">
  <h4>Sort By:</h4>
  <select value={sortValue} on:change={handleChange} {disabled}>
    {#each options as option}
      <option value={option.value}>{option.label}</option>
    {/each}
  </select>
</div>

<style>
  select {
    min-width: 186px;
    height: 30px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    color: #4a4a4a;
    padding: 0px 15px;
    margin-right: 0;
  }

  @media screen and (min-width: 981px) {
    .wrapper {
      position: absolute;
      top: 30px;
      right: 30px;
      z-index: 1;

      display: flex;
      align-items: center;
    }

    .wrapper h4 {
      margin-right: 14px;
    }
  }

  @media (max-width: 980px) {
    h4 {
      font-family: "Segoe UI", sans-serif;
      font-size: 16px;
      line-height: 20px;
      color: #4a4a4a;
    }
    select {
      width: 100%;
      height: 58px;
    }
  }
</style>
